<ng-container *ngIf="curLayout!=='classy'">
    <ng-container *ngIf="show">
        <mat-progress-bar
                [mode]="mode"
                [value]="progress"></mat-progress-bar>
    </ng-container>
</ng-container>
